'use client';

import { TrackBlockImpression } from '@monoimin/analytics';
import { C2AAnalyticsClientProps } from '@monoimin/sb-types';

export const AnalyticsClient = (
  props: C2AAnalyticsClientProps & { className?: string }
) => <TrackBlockImpression {...props} component_type='c2a' />;
